import { useCurrentUserRole } from "Hooks/useCurrentUserAccessRole";
import { AccessRoleCodes, type AccessRoleCode } from "Models/AccessRoleCodes";
import { type Page, appUrl } from "Utils/UrlUtils";

// Role -> payment-creation entry the role is authorized for. Roles without a
// "Pay Me" / keypad capability map to null, which hides the "Create another
// payment" button instead of bouncing them to the sign-in screen.
const ROLE_TO_NEW_PAYMENT_PAGE: Record<AccessRoleCode, Page | null> = {
  [AccessRoleCodes.Merchant]: "initiate-keypad-payment",
  [AccessRoleCodes.Employee]: "employee-initiate-keypad-payment",
  [AccessRoleCodes.Customer]: "initiate-form-payment",
  [AccessRoleCodes.Admin]: null,
  [AccessRoleCodes.AdminLite]: null,
  [AccessRoleCodes.Hunter]: null,
  [AccessRoleCodes.HunterPlus]: null,
  [AccessRoleCodes.Aml]: null,
  [AccessRoleCodes.CustomerOnboarding]: null,
  [AccessRoleCodes.Disponent]: null,
  [AccessRoleCodes.Child]: null,
};

export const useNewPaymentPageLink = (): string | null => {
  const userRole = useCurrentUserRole();
  const page = userRole ? ROLE_TO_NEW_PAYMENT_PAGE[userRole] : null;

  return page ? appUrl(page) : null;
};
